module.exports = __webpack_public_path__ + "img/accessory_item_14.8e70b6a1.svg";